import { render, staticRenderFns } from "./StepPage.vue?vue&type=template&id=4fe5d2c0&scoped=true"
import script from "./StepPage.vue?vue&type=script&lang=js"
export * from "./StepPage.vue?vue&type=script&lang=js"
import style0 from "./StepPage.vue?vue&type=style&index=0&id=4fe5d2c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe5d2c0",
  null
  
)

export default component.exports